module.exports = __webpack_public_path__ + "img/badge-cc-fill.ed891e05.svg";